module.exports = __webpack_public_path__ + "img/start_game_on.e23a8e37.jpg";